import { render, staticRenderFns } from "./noDataView.vue?vue&type=template&id=4ee4bce6&scoped=true&"
import script from "./noDataView.vue?vue&type=script&lang=js&"
export * from "./noDataView.vue?vue&type=script&lang=js&"
import style0 from "./noDataView.vue?vue&type=style&index=0&id=4ee4bce6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee4bce6",
  null
  
)

export default component.exports